import { useQuery } from 'data-fetching-client';
import { GET_ACTIVE_QUOTE_PUBLIC_ID } from 'pricing-pages-api/quotes/queries';
import { useState } from 'react';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
export const useActiveQuoteBanner = ({
  apiNames,
  skip = false
} = {}) => {
  var _data$activeQuotePubl;
  const [isClosed, setIsClosed] = useState(false);
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const {
    data,
    loading,
    error
  } = useQuery(GET_ACTIVE_QUOTE_PUBLIC_ID, {
    variables: {
      apiNames
    },
    skip: skip || !isAppAuth
  });
  const activeQuotePublicId = data === null || data === void 0 || (_data$activeQuotePubl = data.activeQuotePublicId) === null || _data$activeQuotePubl === void 0 ? void 0 : _data$activeQuotePubl.activeQuotePublicId;
  const shouldShowActiveQuoteBanner = Boolean(activeQuotePublicId) && !isClosed;
  const handleClickClose = () => {
    setIsClosed(true);
  };
  return {
    shouldShowActiveQuoteBanner,
    activeQuotePublicId,
    handleClickClose,
    loading,
    error
  };
};